// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 灵感画布项目管理页面样式 - 瀑布流高级版
 */

/* 滚动条样式优化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
  transition: background 0.2s;
}

::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* 容器基础样式 */
.InspirationCanvas-container {
  min-height: calc(100vh - 60px);
  background: #f3f5f6;
  overflow-x: hidden;
  max-width: 100vw;
  display: block;
}

/* 右侧内容区 */
.InspirationCanvas-body {
  min-height: calc(100vh - 60px);
  width: calc(100% - 88px);
  margin-left: 88px;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 - 极简风格 */
.InspirationCanvas-header {
  background: #f3f5f6;
  position: relative;
  z-index: 10;
  border-bottom: 1px solid #e2e6e4;
  transition: all 0.3s ease;
}

.InspirationCanvas-header-inner {
  max-width: 1800px; /* 更宽的视口 */
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  min-height: 170px;
  display: grid;
  place-items: center;
  padding-top: 34px;
  padding-bottom: 30px;
}

.InspirationCanvas-heading {
  min-width: 0;
  width: 100%;
  max-width: 900px;
  text-align: center;
}

.InspirationCanvas-heading h1 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  gap: 12px;
  margin: 0;
  color: #171a17;
  font-family: Georgia, 'Songti SC', serif;
  font-size: clamp(30px, 3.2vw, 52px);
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.03;
  white-space: nowrap;
}

.InspirationCanvas-brand-logo {
  display: block;
  width: min(360px, 76vw);
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.InspirationCanvas-heading .InspirationCanvas-brand-logo {
  max-width: 100%;
}

.InspirationCanvas-heading h1 .InspirationCanvas-brand-logo {
  width: min(360px, calc(100% - 120px));
  max-width: 100%;
  margin: 0;
  flex: 0 1 auto;
}

/* Tab 切换样式 - 左侧对齐 */
.InspirationCanvas-tabs {
  display: flex;
  gap: 8px;
  align-items: center;
}

.InspirationCanvas-tab {
  min-width: 92px;
  padding: 10px 15px;
  color: #74796f;
  border: 1px solid #bdbbb1;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  user-select: none;
}

.InspirationCanvas-tab span {
  margin-left: 5px;
  font-family: Georgia, serif;
}

.InspirationCanvas-tab:hover {
  color: #1e293b;
}

.InspirationCanvas-tab.active {
  color: #11120f;
  background: #d8ff45;
  border-color: #11120f;
  font-size: 0.82rem;
}

.InspirationCanvas-tab.active::after {
  display: none;
}

/* 主内容区 */
.InspirationCanvas-main {
  padding: 2rem 2rem 4rem;
  max-width: 1800px;
  width: 100%;
  margin: 0 auto;
  flex: 1;
}

.InspirationCanvas-body.is-mine .InspirationCanvas-header {
  display: none;
}

.InspirationCanvas-body.is-mine .InspirationCanvas-main {
  padding-top: 30px;
}

.InspirationCanvas-section-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 18px;
}

.InspirationCanvas-section-header h2 {
  margin: 0;
  color: #171a17;
  font-size: 21px;
  font-weight: 720;
  letter-spacing: 0;
  line-height: 1.2;
}

.InspirationCanvas-section-header p {
  margin: 0 0 2px;
  color: #737b75;
  font-size: 12px;
}

.InspirationCanvas-create-project-button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  color: #315327;
  background: #e3f3cb;
  border: 1px solid #b9df8a;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.InspirationCanvas-create-project-button:hover {
  color: #203b20;
  background: #d8efb9;
  border-color: #8fbd5c;
  transform: translateY(-1px);
}

.InspirationCanvas-create-project-button:focus-visible,
.InspirationCanvas-project-menu-trigger:focus-visible,
.InspirationCanvas-project-menu-popover button:focus-visible {
  outline: 2px solid #70a33d;
  outline-offset: 2px;
}

.InspirationCanvas-masonry-container.is-mine-projects {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 26px 20px;
  align-items: start;
}

.InspirationCanvas-masonry-container.is-mine-projects .InspirationCanvas-masonry-column {
  display: contents;
}

.InspirationCanvas-masonry-container.is-mine-projects .InspirationCanvas-masonry-item {
  min-width: 0;
  transform: none;
}

.InspirationCanvas-masonry-container.is-mine-projects .InspirationCanvas-masonry-item:focus-visible {
  outline: none;
}

.InspirationCanvas-masonry-container.is-mine-projects .InspirationCanvas-masonry-item:focus-visible .InspirationCanvas-card-thumbnail {
  outline: 2px solid #70a33d;
  outline-offset: 3px;
}

@media (max-width: 1100px) {
  .InspirationCanvas-masonry-container.is-mine-projects {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .InspirationCanvas-masonry-container.is-mine-projects {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px 16px;
  }
}

.InspirationCanvas-campaign {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 36px;
  overflow: hidden;
  margin-bottom: 30px;
  padding: 28px 32px;
  border: 1px solid #d9e5cf;
  border-radius: 24px 6px 24px 6px;
  background:
    radial-gradient(circle at 88% 8%, rgba(144, 181, 91, .2), transparent 30%),
    linear-gradient(135deg, #fffdf7 0%, #f5f8ed 58%, #edf4e3 100%);
  color: #203020;
  box-shadow: 0 18px 48px rgba(48, 73, 37, .1);
}

.InspirationCanvas-campaign-cover {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: .08;
  object-fit: cover;
}

.InspirationCanvas-campaign-copy,
.InspirationCanvas-campaign-reward { position: relative; z-index: 1; }
.InspirationCanvas-campaign-copy { max-width: 880px; }
.InspirationCanvas-campaign-eyebrow { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin-bottom: 12px; }
.InspirationCanvas-campaign-eyebrow span { padding: 5px 10px; border: 1px solid #c6dba2; border-radius: 999px; background: #e5f1cf; color: #426426; font-size: 10px; font-weight: 800; letter-spacing: .08em; }
.InspirationCanvas-campaign-eyebrow time { color: #7b8675; font-size: 11px; }
.InspirationCanvas-campaign h2 { margin: 0 0 8px; color: #1d2b1d; font-family: Georgia, 'Songti SC', serif; font-size: clamp(25px, 3vw, 40px); font-weight: 500; letter-spacing: -.03em; }
.InspirationCanvas-campaign p { margin: 0; color: #657060; font-size: 13px; }
.InspirationCanvas-campaign-progress { width: min(540px, 100%); height: 5px; overflow: hidden; margin-top: 20px; border-radius: 99px; background: #dce4d5; }
.InspirationCanvas-campaign-progress span { display: block; height: 100%; border-radius: inherit; background: linear-gradient(90deg, #6f9848, #a3bf70); }
.InspirationCanvas-campaign-copy > small { display: block; margin-top: 8px; color: #7d8877; font-size: 10px; }
.InspirationCanvas-campaign-reward { display: grid; min-width: 220px; justify-items: center; padding-left: 28px; border-left: 1px solid #d7e2ce; }
.InspirationCanvas-campaign-reward > span { color: #7c8875; font-size: 10px; letter-spacing: .12em; }
.InspirationCanvas-campaign-reward > strong { margin: 2px 0 -3px; color: #4e742f; font-family: Georgia, serif; font-size: 48px; font-weight: 500; }
.InspirationCanvas-campaign-reward > small { color: #74806e; font-size: 11px; }
.InspirationCanvas-campaign-reward button { width: 100%; min-height: 42px; margin-top: 16px; padding: 9px 17px; border: 1px solid #315327; border-radius: 999px; background: #315327; color: #fff; box-shadow: 0 8px 20px rgba(49, 83, 39, .16); font-size: 11px; font-weight: 800; cursor: pointer; transition: background 160ms ease, border-color 160ms ease, transform 160ms ease; }
.InspirationCanvas-campaign-reward button:hover:not(:disabled) { border-color: #426b32; background: #426b32; transform: translateY(-1px); }
.InspirationCanvas-campaign-reward button:disabled { border-color: #d5ddd0; background: #e7ece4; color: #8b9587; box-shadow: none; cursor: not-allowed; }
.InspirationCanvas-campaign.is-full .InspirationCanvas-campaign-eyebrow span,
.InspirationCanvas-campaign.is-paused .InspirationCanvas-campaign-eyebrow span { border-color: #e1c897; background: #f7e9cd; color: #815d27; }

.InspirationCanvas-login-prompt {
  display: grid;
  min-height: 190px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 20px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #dfe4e0;
  border-radius: 16px;
  box-shadow: 0 10px 32px rgba(24, 30, 26, 0.06);
}

.InspirationCanvas-login-prompt-mark {
  display: grid;
  width: 54px;
  height: 54px;
  place-items: center;
  color: #fff;
  background: #171a17;
  border-radius: 15px;
  font-size: 22px;
  font-weight: 700;
}

.InspirationCanvas-login-prompt h3 { margin: 0 0 7px; color: #171a17; font-size: 18px; }
.InspirationCanvas-login-prompt p { margin: 0; color: #737b75; font-size: 13px; }
.InspirationCanvas-login-prompt button {
  min-height: 42px;
  padding: 9px 20px;
  color: #171a17;
  background: #e3f3cb;
  border: 1px solid #b9df8a;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.InspirationCanvas-login-prompt button:hover { background: #d7edb8; border-color: #8fbd5c; }

/* 瀑布流布局 - Flex 分列实现 */
.InspirationCanvas-masonry-container {
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
}

.InspirationCanvas-masonry-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0; /* 防止 flex item 溢出 */
}

.InspirationCanvas-skeleton-grid {
  display: grid;
  grid-template-columns: repeat(var(--InspirationCanvas-skeleton-columns), minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  margin-top: 16px;
}

.InspirationCanvas-skeleton-item {
  min-width: 0;
}

.InspirationCanvas-skeleton-card {
  position: relative;
  min-height: 118px;
  overflow: hidden;
  border-radius: 3px 22px 3px 3px;
  background: #e3eae6;
}

.InspirationCanvas-skeleton-shimmer,
.InspirationCanvas-card-image-skeleton {
  position: absolute;
  inset: 0;
  display: block;
  background: linear-gradient(108deg, #e3eae6 18%, #f2f5f1 42%, #e3eae6 66%);
  background-size: 220% 100%;
  animation: InspirationCanvas-skeleton-shimmer 1.35s ease-in-out infinite;
}

@keyframes InspirationCanvas-skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -20% 0; }
}

/* 瀑布流卡片容器 */
.InspirationCanvas-masonry-item {
  position: relative;
  transform: translateZ(0); /* 硬件加速 */
  transition: z-index 0s; /* 只有 hover 时提高 z-index */
}

.InspirationCanvas-masonry-item:hover {
  z-index: 2; /* 悬停时层级提高 */
}

/* 卡片内容 */
.InspirationCanvas-card-content {
  background: #11120f;
  border-radius: 3px 22px 3px 3px;
  /* border-radius: 8px; */ /* 不规则排布通常不需要太大圆角，或者很小的圆角 */
  overflow: hidden; /* 溢出隐藏 */
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); */ /* 去掉阴影，更像图片墙 */
  position: relative;
  cursor: pointer;
  /* transition: box-shadow 0.3s ease; */
}

/* 图片容器 - 高度自适应 */
.InspirationCanvas-card-thumbnail {
  position: relative;
  width: 100%;
  background: #f1f5f9;
  display: block;
  overflow: hidden;
}

.InspirationCanvas-card-content:not(.is-mine-project) .InspirationCanvas-card-thumbnail.is-loading {
  min-height: 180px;
}

.InspirationCanvas-card-thumbnail img {
  width: 100%;
  height: auto; /* 保持原始比例 */
  display: block; /* 消除底部空隙 */
  position: relative;
  z-index: 1;
  transition: transform 0.5s ease;
}

.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-thumbnail.is-loading {
  min-height: 0;
}

/* 鼠标放到盒子上，里面的图片放大 */
.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-thumbnail img {
  transform: scale(1.045);
}

/* 占位符 */
.InspirationCanvas-card-placeholder {
  width: 100%;
  padding-top: 100%; /* 默认正方形 */
  position: relative;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.InspirationCanvas-card-placeholder svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #94a3b8;
}

/* 信息浮层 - 常驻显示 */
.InspirationCanvas-card-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px 16px 12px;
  /* 更加明显的渐变，保证文字可见性 */
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 60%, transparent 100%);
  opacity: 1; /* 常驻显示 */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  pointer-events: none; /* 保证点击穿透 */
}

.InspirationCanvas-card-title {
  color: white;
  font-family: Georgia, 'Songti SC', serif;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 1px 3px rgba(0,0,0,0.5);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.InspirationCanvas-card-content.is-mine-project {
  overflow: visible;
  background: transparent;
  border-radius: 0;
}

.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-thumbnail {
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  background: #e2e8e5;
}

.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-placeholder {
  height: 100%;
  padding-top: 0;
  background: #e8eeea;
}

.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-info {
  position: static;
  display: block;
  padding: 9px 1px 0;
  background: transparent;
  pointer-events: auto;
}

.InspirationCanvas-card-meta-row {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-title {
  min-width: 0;
  overflow: hidden;
  color: #171a17;
  font-family: inherit;
  font-size: 12px;
  font-weight: 680;
  line-height: 1.4;
  text-overflow: ellipsis;
  text-shadow: none;
  white-space: nowrap;
}

.InspirationCanvas-project-date {
  display: block;
  margin-top: 5px;
  color: #737b75;
  font-size: 10px;
  line-height: 1.3;
}

.InspirationCanvas-project-menu {
  position: relative;
  flex: 0 0 auto;
}

.InspirationCanvas-project-menu-trigger {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  padding: 0;
  color: #737b75;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.InspirationCanvas-project-menu-trigger:hover,
.InspirationCanvas-project-menu-trigger[aria-expanded='true'] {
  color: #171a17;
  background: #eef2ef;
  border-color: #dfe5e1;
}

.InspirationCanvas-project-menu-popover {
  position: absolute;
  z-index: 30;
  top: calc(100% + 7px);
  right: 0;
  display: grid;
  min-width: 136px;
  gap: 2px;
  padding: 5px;
  background: #fff;
  border: 1px solid #dfe5e1;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(24, 30, 26, 0.14);
}

.InspirationCanvas-project-menu-popover button {
  width: 100%;
  padding: 8px 9px;
  color: #4f5b52;
  background: transparent;
  border: 0;
  border-radius: 5px;
  font-size: 11px;
  text-align: left;
  cursor: pointer;
}

.InspirationCanvas-project-menu-popover button:hover {
  color: #171a17;
  background: #f1f3f2;
}

.InspirationCanvas-project-menu-popover button.is-danger {
  color: #c1514b;
}

.InspirationCanvas-project-menu-popover button.is-danger:hover {
  color: #a33c37;
  background: #fff0ee;
}

.InspirationCanvas-project-menu-divider {
  height: 1px;
  margin: 3px 2px;
  background: #e8ece9;
}

.InspirationCanvas-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.InspirationCanvas-card-moderation-status {
  display: inline-flex;
  margin-top: 7px;
  padding: 4px 8px;
  border-radius: 999px;
  background: #fee8e5;
  color: #a43b34;
  font-size: 10px;
  font-weight: 700;
}

.InspirationCanvas-moderation-notice {
  display: grid;
  gap: 4px;
  margin-top: 10px;
  padding: 11px 12px;
  border: 1px solid #efc1bc;
  border-radius: 9px;
  background: #fff4f2;
  color: #8d332d;
  font-size: 12px;
  line-height: 1.45;
}

.InspirationCanvas-moderation-notice span { color: #a1554f; }

@media (max-width: 820px) {
  .InspirationCanvas-header-inner {
    min-height: 170px;
    place-items: center;
    padding: 32px 1rem 24px;
  }

  .InspirationCanvas-main { padding: 1rem 1rem 3rem; }
}

/* 操作按钮 - 悬停显示 */
.InspirationCanvas-card-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 6px;
  z-index: 10;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-actions {
  opacity: 1;
  transform: translateY(0);
}

.InspirationCanvas-action-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  border: none;
  color: #1e293b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.InspirationCanvas-action-btn:hover {
  background: white;
  transform: scale(1.1);
}

.InspirationCanvas-delete-btn:hover {
  color: #ef4444;
}

.InspirationCanvas-edit-btn:hover {
  color: #3b82f6;
}

/* 创建卡片 - 极简风格 */
.InspirationCanvas-create-card {
  background: white;
  /* border-radius: 8px; */
  border: 2px dashed #cbd5e1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 200px; /* 不需要太高 */
  box-shadow: none;
  height: 100%; /* 撑满 */
}

.InspirationCanvas-create-card:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.InspirationCanvas-create-content {
  text-align: center;
  padding: 1.5rem;
}

.InspirationCanvas-create-icon {
  color: #94a3b8;
  margin-bottom: 0.75rem;
  transition: transform 0.3s ease;
}

.InspirationCanvas-create-card:hover .InspirationCanvas-create-icon {
  transform: scale(1.1) rotate(90deg);
  color: #64748b;
}

.InspirationCanvas-create-text {
  font-size: 1rem;
  font-weight: 700;
  color: #64748b;
  margin: 0;
}

/* 状态提示 */
.InspirationCanvas-loading,
.InspirationCanvas-no-more,
.InspirationCanvas-empty-message {
  text-align: center;
  padding: 3rem;
  color: #94a3b8;
  font-size: 0.95rem;
  font-weight: 500;
  width: 100%;
}

.InspirationCanvas-error {
  text-align: center;
  padding: 2rem;
  background: #fef2f2;
  border-radius: 12px;
  border: 1px solid #fecaca;
  margin-bottom: 2rem;
  color: #b91c1c;
}

/* 对话框样式 */
.InspirationCanvas-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6); /* 加深背景 */
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.InspirationCanvas-dialog {
  background: white;
  border-radius: 24px;
  padding: 2.5rem;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: dialogPop 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes dialogPop {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.InspirationCanvas-dialog-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 1.5rem 0;
  text-align: center;
}

.InspirationCanvas-form-input,
.InspirationCanvas-form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.2s;
  background: #f8fafc;
  color: #1e293b;
}

.InspirationCanvas-form-input:focus,
.InspirationCanvas-form-textarea:focus {
  background: white;
  border-color: #0f172a;
  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);
  outline: none;
}

.InspirationCanvas-dialog-actions {
  display: flex;
  gap: 12px;
  margin-top: 2rem;
}

.InspirationCanvas-dialog-button {
  flex: 1;
  padding: 12px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}

.InspirationCanvas-dialog-button-cancel {
  background: #f1f5f9;
  color: #64748b;
}

.InspirationCanvas-dialog-button-cancel:hover {
  background: #e2e8f0;
  color: #334155;
}

.InspirationCanvas-dialog-button-save {
  background: #0f172a;
  color: white;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);
}

.InspirationCanvas-dialog-button-save:hover {
  background: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.25);
}

.InspirationCanvas-dialog-button-delete {
  background: #ef4444;
  color: white;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.InspirationCanvas-dialog-button-delete:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

.InspirationCanvas-cover-dialog {
  max-width: 760px;
  padding: 24px;
}

.InspirationCanvas-cover-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}

.InspirationCanvas-cover-dialog-header .InspirationCanvas-dialog-title {
  margin-bottom: 6px;
  text-align: left;
}

.InspirationCanvas-cover-dialog-subtitle {
  margin: 0;
  color: #737b75;
  font-size: 12px;
  line-height: 1.5;
}

.InspirationCanvas-cover-dialog-close {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  place-items: center;
  padding: 0;
  color: #737b75;
  background: #f1f3f2;
  border: 1px solid #e1e7e3;
  border-radius: 8px;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.InspirationCanvas-cover-dialog-close:hover {
  color: #171a17;
  background: #e7ebe8;
  border-color: #d3dbd5;
}

.InspirationCanvas-cover-dialog-close:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.InspirationCanvas-cover-picker {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  max-height: min(55vh, 460px);
  overflow-y: auto;
  padding: 2px;
}

.InspirationCanvas-cover-option {
  min-width: 0;
  padding: 0;
  color: #4f5b52;
  text-align: left;
  background: #fff;
  border: 1px solid #dfe5e1;
  border-radius: 9px;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.InspirationCanvas-cover-option:hover {
  border-color: #a9c880;
  box-shadow: 0 6px 16px rgba(54, 73, 57, 0.11);
  transform: translateY(-1px);
}

.InspirationCanvas-cover-option:focus-visible,
.InspirationCanvas-cover-dialog-close:focus-visible,
.InspirationCanvas-cover-upload-button:focus-visible,
.InspirationCanvas-cover-retry:focus-visible {
  outline: 3px solid rgba(126, 174, 71, 0.3);
  outline-offset: 2px;
}

.InspirationCanvas-cover-option.is-selected {
  border-color: #7eae47;
  box-shadow: 0 0 0 2px rgba(126, 174, 71, 0.2);
}

.InspirationCanvas-cover-option-image {
  position: relative;
  display: block;
  aspect-ratio: 4 / 3;
  background: #e8eeea;
}

.InspirationCanvas-cover-option-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.InspirationCanvas-cover-option-check {
  position: absolute;
  top: 8px;
  right: 8px;
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  color: #fff;
  background: #7eae47;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(40, 62, 34, 0.24);
}

.InspirationCanvas-cover-option-label {
  display: block;
  overflow: hidden;
  padding: 9px 10px 10px;
  color: #4f5b52;
  font-size: 11px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.InspirationCanvas-cover-state {
  display: flex;
  min-height: 180px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 24px;
  color: #5e6a61;
  background: #f5f7f5;
  border: 1px dashed #d3ddd5;
  border-radius: 9px;
  font-size: 13px;
}

.InspirationCanvas-cover-state.is-error,
.InspirationCanvas-cover-state.is-empty {
  flex-direction: column;
  text-align: center;
}

.InspirationCanvas-cover-state.is-error {
  color: #a33c37;
  background: #fff5f3;
  border-color: #efc1bc;
}

.InspirationCanvas-cover-state.is-error span,
.InspirationCanvas-cover-state.is-empty span {
  color: #737b75;
  font-size: 12px;
}

.InspirationCanvas-cover-retry {
  padding: 7px 12px;
  color: #4f7e2e;
  background: #e3f3cb;
  border: 1px solid #b9df8a;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.InspirationCanvas-cover-retry:hover {
  background: #d8efb9;
  border-color: #8fbd5c;
}

.InspirationCanvas-cover-retry:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.InspirationCanvas-cover-state.is-empty svg {
  color: #9aaa9d;
  margin-bottom: 2px;
}

.InspirationCanvas-cover-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #d7e2ce;
  border-top-color: #7eae47;
  border-radius: 50%;
  animation: InspirationCanvas-cover-spin 700ms linear infinite;
}

@keyframes InspirationCanvas-cover-spin {
  to { transform: rotate(360deg); }
}

.InspirationCanvas-cover-dialog-footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-top: 20px;
}

.InspirationCanvas-cover-dialog-footer .InspirationCanvas-dialog-actions {
  min-width: 260px;
  margin-top: 0;
}

.InspirationCanvas-cover-upload-button {
  padding: 10px 2px;
  color: #657461;
  background: transparent;
  border: 0;
  font-size: 12px;
  cursor: pointer;
}

.InspirationCanvas-cover-upload-button:hover {
  color: #4f7e2e;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.InspirationCanvas-cover-upload-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

/* 升级弹窗相关复用 */
.InspirationCanvas-upgrade-dialog {
  text-align: center;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.InspirationCanvas-upgrade-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fef3c7;
  color: #d97706;
}

.InspirationCanvas-upgrade-message {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  color: #0369a1;
  padding: 1rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.InspirationCanvas-upgrade-benefits {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
  text-align: left;
}

.InspirationCanvas-upgrade-benefits li {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #475569;
}

.InspirationCanvas-upgrade-benefits li::before {
  content: '✓';
  color: #10b981;
  font-weight: 800;
}

.InspirationCanvas-upgrade-button {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .InspirationCanvas-body {
    width: calc(100% - 76px);
    margin-left: 76px;
  }

  .InspirationCanvas-header-inner {
    min-height: 150px;
    padding: 24px 12px 20px;
  }

  .InspirationCanvas-main {
    padding: 1rem 1rem 3rem;
  }

  .InspirationCanvas-campaign {
    grid-template-columns: 1fr;
    gap: 22px;
    padding: 24px;
  }

  .InspirationCanvas-campaign-reward {
    grid-template-columns: auto auto 1fr;
    min-width: 0;
    justify-items: start;
    align-items: baseline;
    gap: 6px;
    padding: 20px 0 0;
    border-top: 1px solid #d7e2ce;
    border-left: 0;
  }

  .InspirationCanvas-campaign-reward > strong { font-size: 38px; }
  .InspirationCanvas-campaign-reward button { grid-column: 1 / -1; }
  
  .InspirationCanvas-masonry-container {
    gap: 2px;
  }
  
  .InspirationCanvas-masonry-column {
    gap: 2px;
  }

  .InspirationCanvas-skeleton-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  
  .InspirationCanvas-create-card {
    min-height: 160px;
  }

  .InspirationCanvas-login-prompt {
    grid-template-columns: auto 1fr;
    gap: 14px;
    padding: 22px;
  }

  .InspirationCanvas-login-prompt button { grid-column: 1 / -1; }
}

@media (max-width: 720px) {
  .InspirationCanvas-header .InspirationCanvas-header-inner {
    min-height: 140px;
    padding: 20px 10px;
  }

  .InspirationCanvas-heading h1 {
    gap: 8px;
    font-size: 24px;
  }

  .InspirationCanvas-heading h1 .InspirationCanvas-brand-logo {
    width: calc(100% - 108px);
    max-width: 100%;
  }

  .InspirationCanvas-body {
    width: calc(100% - 68px);
    margin-left: 68px;
  }
}

@media (max-width: 620px) {
  .InspirationCanvas-skeleton-grid {
    grid-template-columns: 1fr;
  }

  .InspirationCanvas-cover-dialog {
    padding: 18px;
  }

  .InspirationCanvas-cover-picker {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 9px;
    max-height: 52vh;
  }

  .InspirationCanvas-cover-dialog-footer {
    align-items: stretch;
    flex-direction: column-reverse;
    gap: 8px;
  }

  .InspirationCanvas-cover-dialog-footer .InspirationCanvas-dialog-actions {
    width: 100%;
    min-width: 0;
  }

  .InspirationCanvas-cover-upload-button {
    align-self: flex-start;
  }

  .InspirationCanvas-body.is-mine .InspirationCanvas-main {
    padding: 28px 14px 56px;
  }

  .InspirationCanvas-section-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 22px;
  }

  .InspirationCanvas-create-project-button {
    width: 100%;
    justify-content: center;
  }

  .InspirationCanvas-masonry-container.is-mine-projects {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/inspirationCanvas/InspirationCanvas.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,YAAY;AACZ;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB,EAAE,UAAU;EAC7B,WAAW;EACX,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kGAAkG;AACpG;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC;;kEAEgE;EAChE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;qCACqC,kBAAkB,EAAE,UAAU,EAAE;AACrE,mCAAmC,gBAAgB,EAAE;AACrD,sCAAsC,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC3H,2CAA2C,iBAAiB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC9M,2CAA2C,cAAc,EAAE,eAAe,EAAE;AAC5E,iCAAiC,eAAe,EAAE,cAAc,EAAE,wCAAwC,EAAE,iCAAiC,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACzL,gCAAgC,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5E,uCAAuC,uBAAuB,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC3J,4CAA4C,cAAc,EAAE,YAAY,EAAE,sBAAsB,EAAE,oDAAoD,EAAE;AACxJ,2CAA2C,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7G,qCAAqC,aAAa,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;AACjJ,4CAA4C,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACpG,8CAA8C,kBAAkB,EAAE,cAAc,EAAE,2BAA2B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAClJ,6CAA6C,cAAc,EAAE,eAAe,EAAE;AAC9E,4CAA4C,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,WAAW,EAAE,4CAA4C,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,gFAAgF,EAAE;AACvX,iEAAiE,qBAAqB,EAAE,mBAAmB,EAAE,2BAA2B,EAAE;AAC1I,qDAAqD,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACxJ;iFACiF,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAE7I;EACE,aAAa;EACb,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACvF,oCAAoC,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAChF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,+CAA+C,mBAAmB,EAAE,qBAAqB,EAAE;;AAE3F,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,EAAE,oBAAoB;AACpC;;AAEA;EACE,aAAa;EACb,wFAAwF;EACxF,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,0EAA0E;EAC1E,0BAA0B;EAC1B,wEAAwE;AAC1E;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,wBAAwB,EAAE,SAAS;EACnC,sBAAsB,EAAE,yBAAyB;AACnD;;AAEA;EACE,UAAU,EAAE,YAAY;AAC1B;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB,EAAE,2BAA2B;EACrD,gBAAgB,EAAE,SAAS;EAC3B,gDAAgD,EAAE,eAAe;EACjE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,WAAW;EACzB,cAAc,EAAE,WAAW;EAC3B,kBAAkB;EAClB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;AACzB;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,iBAAiB,EAAE,UAAU;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,oBAAoB;EACpB,8FAA8F;EAC9F,UAAU,EAAE,SAAS;EACrB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB,EAAE,WAAW;AACnC;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,4CAA4C,cAAc,EAAE;;AAE5D;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,0BAA0B,uBAAuB,EAAE;AACrD;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,QAAQ;EACR,WAAW;EACX,UAAU;EACV,4BAA4B;EAC5B,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB,EAAE,UAAU;EAC7B,gBAAgB;EAChB,YAAY,EAAE,OAAO;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,SAAS;AACT;;;EAGE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B,EAAE,SAAS;EACzC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,uDAAuD;AACzD;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;;;;EAIE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,UAAU;AACV;EACE;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,oCAAoC;IACpC,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,QAAQ;IACR,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;EAChB;;EAEA,8CAA8C,eAAe,EAAE;EAC/D,4CAA4C,mBAAmB,EAAE;;EAEjE;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,SAAS;IACT,aAAa;EACf;;EAEA,yCAAyC,mBAAmB,EAAE;AAChE;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;IAChD,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":["/**\n * 灵感画布项目管理页面样式 - 瀑布流高级版\n */\n\n/* 滚动条样式优化 */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 3px;\n  transition: background 0.2s;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n/* 容器基础样式 */\n.InspirationCanvas-container {\n  min-height: calc(100vh - 60px);\n  background: #f3f5f6;\n  overflow-x: hidden;\n  max-width: 100vw;\n  display: block;\n}\n\n/* 右侧内容区 */\n.InspirationCanvas-body {\n  min-height: calc(100vh - 60px);\n  width: calc(100% - 88px);\n  margin-left: 88px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 顶部导航栏 - 极简风格 */\n.InspirationCanvas-header {\n  background: #f3f5f6;\n  position: relative;\n  z-index: 10;\n  border-bottom: 1px solid #e2e6e4;\n  transition: all 0.3s ease;\n}\n\n.InspirationCanvas-header-inner {\n  max-width: 1800px; /* 更宽的视口 */\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 2rem;\n  min-height: 170px;\n  display: grid;\n  place-items: center;\n  padding-top: 34px;\n  padding-bottom: 30px;\n}\n\n.InspirationCanvas-heading {\n  min-width: 0;\n  width: 100%;\n  max-width: 900px;\n  text-align: center;\n}\n\n.InspirationCanvas-heading h1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  gap: 12px;\n  margin: 0;\n  color: #171a17;\n  font-family: Georgia, 'Songti SC', serif;\n  font-size: clamp(30px, 3.2vw, 52px);\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.03;\n  white-space: nowrap;\n}\n\n.InspirationCanvas-brand-logo {\n  display: block;\n  width: min(360px, 76vw);\n  max-width: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n\n.InspirationCanvas-heading .InspirationCanvas-brand-logo {\n  max-width: 100%;\n}\n\n.InspirationCanvas-heading h1 .InspirationCanvas-brand-logo {\n  width: min(360px, calc(100% - 120px));\n  max-width: 100%;\n  margin: 0;\n  flex: 0 1 auto;\n}\n\n/* Tab 切换样式 - 左侧对齐 */\n.InspirationCanvas-tabs {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.InspirationCanvas-tab {\n  min-width: 92px;\n  padding: 10px 15px;\n  color: #74796f;\n  border: 1px solid #bdbbb1;\n  border-radius: 999px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  user-select: none;\n}\n\n.InspirationCanvas-tab span {\n  margin-left: 5px;\n  font-family: Georgia, serif;\n}\n\n.InspirationCanvas-tab:hover {\n  color: #1e293b;\n}\n\n.InspirationCanvas-tab.active {\n  color: #11120f;\n  background: #d8ff45;\n  border-color: #11120f;\n  font-size: 0.82rem;\n}\n\n.InspirationCanvas-tab.active::after {\n  display: none;\n}\n\n/* 主内容区 */\n.InspirationCanvas-main {\n  padding: 2rem 2rem 4rem;\n  max-width: 1800px;\n  width: 100%;\n  margin: 0 auto;\n  flex: 1;\n}\n\n.InspirationCanvas-body.is-mine .InspirationCanvas-header {\n  display: none;\n}\n\n.InspirationCanvas-body.is-mine .InspirationCanvas-main {\n  padding-top: 30px;\n}\n\n.InspirationCanvas-section-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 18px;\n}\n\n.InspirationCanvas-section-header h2 {\n  margin: 0;\n  color: #171a17;\n  font-size: 21px;\n  font-weight: 720;\n  letter-spacing: 0;\n  line-height: 1.2;\n}\n\n.InspirationCanvas-section-header p {\n  margin: 0 0 2px;\n  color: #737b75;\n  font-size: 12px;\n}\n\n.InspirationCanvas-create-project-button {\n  display: inline-flex;\n  min-height: 34px;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 12px;\n  color: #315327;\n  background: #e3f3cb;\n  border: 1px solid #b9df8a;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease, transform 160ms ease;\n}\n\n.InspirationCanvas-create-project-button:hover {\n  color: #203b20;\n  background: #d8efb9;\n  border-color: #8fbd5c;\n  transform: translateY(-1px);\n}\n\n.InspirationCanvas-create-project-button:focus-visible,\n.InspirationCanvas-project-menu-trigger:focus-visible,\n.InspirationCanvas-project-menu-popover button:focus-visible {\n  outline: 2px solid #70a33d;\n  outline-offset: 2px;\n}\n\n.InspirationCanvas-masonry-container.is-mine-projects {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 26px 20px;\n  align-items: start;\n}\n\n.InspirationCanvas-masonry-container.is-mine-projects .InspirationCanvas-masonry-column {\n  display: contents;\n}\n\n.InspirationCanvas-masonry-container.is-mine-projects .InspirationCanvas-masonry-item {\n  min-width: 0;\n  transform: none;\n}\n\n.InspirationCanvas-masonry-container.is-mine-projects .InspirationCanvas-masonry-item:focus-visible {\n  outline: none;\n}\n\n.InspirationCanvas-masonry-container.is-mine-projects .InspirationCanvas-masonry-item:focus-visible .InspirationCanvas-card-thumbnail {\n  outline: 2px solid #70a33d;\n  outline-offset: 3px;\n}\n\n@media (max-width: 1100px) {\n  .InspirationCanvas-masonry-container.is-mine-projects {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .InspirationCanvas-masonry-container.is-mine-projects {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 24px 16px;\n  }\n}\n\n.InspirationCanvas-campaign {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 36px;\n  overflow: hidden;\n  margin-bottom: 30px;\n  padding: 28px 32px;\n  border: 1px solid #d9e5cf;\n  border-radius: 24px 6px 24px 6px;\n  background:\n    radial-gradient(circle at 88% 8%, rgba(144, 181, 91, .2), transparent 30%),\n    linear-gradient(135deg, #fffdf7 0%, #f5f8ed 58%, #edf4e3 100%);\n  color: #203020;\n  box-shadow: 0 18px 48px rgba(48, 73, 37, .1);\n}\n\n.InspirationCanvas-campaign-cover {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: .08;\n  object-fit: cover;\n}\n\n.InspirationCanvas-campaign-copy,\n.InspirationCanvas-campaign-reward { position: relative; z-index: 1; }\n.InspirationCanvas-campaign-copy { max-width: 880px; }\n.InspirationCanvas-campaign-eyebrow { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin-bottom: 12px; }\n.InspirationCanvas-campaign-eyebrow span { padding: 5px 10px; border: 1px solid #c6dba2; border-radius: 999px; background: #e5f1cf; color: #426426; font-size: 10px; font-weight: 800; letter-spacing: .08em; }\n.InspirationCanvas-campaign-eyebrow time { color: #7b8675; font-size: 11px; }\n.InspirationCanvas-campaign h2 { margin: 0 0 8px; color: #1d2b1d; font-family: Georgia, 'Songti SC', serif; font-size: clamp(25px, 3vw, 40px); font-weight: 500; letter-spacing: -.03em; }\n.InspirationCanvas-campaign p { margin: 0; color: #657060; font-size: 13px; }\n.InspirationCanvas-campaign-progress { width: min(540px, 100%); height: 5px; overflow: hidden; margin-top: 20px; border-radius: 99px; background: #dce4d5; }\n.InspirationCanvas-campaign-progress span { display: block; height: 100%; border-radius: inherit; background: linear-gradient(90deg, #6f9848, #a3bf70); }\n.InspirationCanvas-campaign-copy > small { display: block; margin-top: 8px; color: #7d8877; font-size: 10px; }\n.InspirationCanvas-campaign-reward { display: grid; min-width: 220px; justify-items: center; padding-left: 28px; border-left: 1px solid #d7e2ce; }\n.InspirationCanvas-campaign-reward > span { color: #7c8875; font-size: 10px; letter-spacing: .12em; }\n.InspirationCanvas-campaign-reward > strong { margin: 2px 0 -3px; color: #4e742f; font-family: Georgia, serif; font-size: 48px; font-weight: 500; }\n.InspirationCanvas-campaign-reward > small { color: #74806e; font-size: 11px; }\n.InspirationCanvas-campaign-reward button { width: 100%; min-height: 42px; margin-top: 16px; padding: 9px 17px; border: 1px solid #315327; border-radius: 999px; background: #315327; color: #fff; box-shadow: 0 8px 20px rgba(49, 83, 39, .16); font-size: 11px; font-weight: 800; cursor: pointer; transition: background 160ms ease, border-color 160ms ease, transform 160ms ease; }\n.InspirationCanvas-campaign-reward button:hover:not(:disabled) { border-color: #426b32; background: #426b32; transform: translateY(-1px); }\n.InspirationCanvas-campaign-reward button:disabled { border-color: #d5ddd0; background: #e7ece4; color: #8b9587; box-shadow: none; cursor: not-allowed; }\n.InspirationCanvas-campaign.is-full .InspirationCanvas-campaign-eyebrow span,\n.InspirationCanvas-campaign.is-paused .InspirationCanvas-campaign-eyebrow span { border-color: #e1c897; background: #f7e9cd; color: #815d27; }\n\n.InspirationCanvas-login-prompt {\n  display: grid;\n  min-height: 190px;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 20px;\n  padding: 30px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid #dfe4e0;\n  border-radius: 16px;\n  box-shadow: 0 10px 32px rgba(24, 30, 26, 0.06);\n}\n\n.InspirationCanvas-login-prompt-mark {\n  display: grid;\n  width: 54px;\n  height: 54px;\n  place-items: center;\n  color: #fff;\n  background: #171a17;\n  border-radius: 15px;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.InspirationCanvas-login-prompt h3 { margin: 0 0 7px; color: #171a17; font-size: 18px; }\n.InspirationCanvas-login-prompt p { margin: 0; color: #737b75; font-size: 13px; }\n.InspirationCanvas-login-prompt button {\n  min-height: 42px;\n  padding: 9px 20px;\n  color: #171a17;\n  background: #e3f3cb;\n  border: 1px solid #b9df8a;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.InspirationCanvas-login-prompt button:hover { background: #d7edb8; border-color: #8fbd5c; }\n\n/* 瀑布流布局 - Flex 分列实现 */\n.InspirationCanvas-masonry-container {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  align-items: flex-start;\n}\n\n.InspirationCanvas-masonry-column {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0; /* 防止 flex item 溢出 */\n}\n\n.InspirationCanvas-skeleton-grid {\n  display: grid;\n  grid-template-columns: repeat(var(--InspirationCanvas-skeleton-columns), minmax(0, 1fr));\n  gap: 10px;\n  width: 100%;\n  margin-top: 16px;\n}\n\n.InspirationCanvas-skeleton-item {\n  min-width: 0;\n}\n\n.InspirationCanvas-skeleton-card {\n  position: relative;\n  min-height: 118px;\n  overflow: hidden;\n  border-radius: 3px 22px 3px 3px;\n  background: #e3eae6;\n}\n\n.InspirationCanvas-skeleton-shimmer,\n.InspirationCanvas-card-image-skeleton {\n  position: absolute;\n  inset: 0;\n  display: block;\n  background: linear-gradient(108deg, #e3eae6 18%, #f2f5f1 42%, #e3eae6 66%);\n  background-size: 220% 100%;\n  animation: InspirationCanvas-skeleton-shimmer 1.35s ease-in-out infinite;\n}\n\n@keyframes InspirationCanvas-skeleton-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -20% 0; }\n}\n\n/* 瀑布流卡片容器 */\n.InspirationCanvas-masonry-item {\n  position: relative;\n  transform: translateZ(0); /* 硬件加速 */\n  transition: z-index 0s; /* 只有 hover 时提高 z-index */\n}\n\n.InspirationCanvas-masonry-item:hover {\n  z-index: 2; /* 悬停时层级提高 */\n}\n\n/* 卡片内容 */\n.InspirationCanvas-card-content {\n  background: #11120f;\n  border-radius: 3px 22px 3px 3px;\n  /* border-radius: 8px; */ /* 不规则排布通常不需要太大圆角，或者很小的圆角 */\n  overflow: hidden; /* 溢出隐藏 */\n  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); */ /* 去掉阴影，更像图片墙 */\n  position: relative;\n  cursor: pointer;\n  /* transition: box-shadow 0.3s ease; */\n}\n\n/* 图片容器 - 高度自适应 */\n.InspirationCanvas-card-thumbnail {\n  position: relative;\n  width: 100%;\n  background: #f1f5f9;\n  display: block;\n  overflow: hidden;\n}\n\n.InspirationCanvas-card-content:not(.is-mine-project) .InspirationCanvas-card-thumbnail.is-loading {\n  min-height: 180px;\n}\n\n.InspirationCanvas-card-thumbnail img {\n  width: 100%;\n  height: auto; /* 保持原始比例 */\n  display: block; /* 消除底部空隙 */\n  position: relative;\n  z-index: 1;\n  transition: transform 0.5s ease;\n}\n\n.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-thumbnail.is-loading {\n  min-height: 0;\n}\n\n/* 鼠标放到盒子上，里面的图片放大 */\n.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-thumbnail img {\n  transform: scale(1.045);\n}\n\n/* 占位符 */\n.InspirationCanvas-card-placeholder {\n  width: 100%;\n  padding-top: 100%; /* 默认正方形 */\n  position: relative;\n  background: #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.InspirationCanvas-card-placeholder svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #94a3b8;\n}\n\n/* 信息浮层 - 常驻显示 */\n.InspirationCanvas-card-info {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 40px 16px 12px;\n  /* 更加明显的渐变，保证文字可见性 */\n  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 60%, transparent 100%);\n  opacity: 1; /* 常驻显示 */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  pointer-events: none; /* 保证点击穿透 */\n}\n\n.InspirationCanvas-card-title {\n  color: white;\n  font-family: Georgia, 'Songti SC', serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  margin: 0;\n  text-shadow: 0 1px 3px rgba(0,0,0,0.5);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.InspirationCanvas-card-content.is-mine-project {\n  overflow: visible;\n  background: transparent;\n  border-radius: 0;\n}\n\n.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-thumbnail {\n  aspect-ratio: 16 / 9;\n  border-radius: 8px;\n  background: #e2e8e5;\n}\n\n.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-placeholder {\n  height: 100%;\n  padding-top: 0;\n  background: #e8eeea;\n}\n\n.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-info {\n  position: static;\n  display: block;\n  padding: 9px 1px 0;\n  background: transparent;\n  pointer-events: auto;\n}\n\n.InspirationCanvas-card-meta-row {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.InspirationCanvas-card-content.is-mine-project .InspirationCanvas-card-title {\n  min-width: 0;\n  overflow: hidden;\n  color: #171a17;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 680;\n  line-height: 1.4;\n  text-overflow: ellipsis;\n  text-shadow: none;\n  white-space: nowrap;\n}\n\n.InspirationCanvas-project-date {\n  display: block;\n  margin-top: 5px;\n  color: #737b75;\n  font-size: 10px;\n  line-height: 1.3;\n}\n\n.InspirationCanvas-project-menu {\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.InspirationCanvas-project-menu-trigger {\n  display: grid;\n  width: 26px;\n  height: 26px;\n  place-items: center;\n  padding: 0;\n  color: #737b75;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;\n}\n\n.InspirationCanvas-project-menu-trigger:hover,\n.InspirationCanvas-project-menu-trigger[aria-expanded='true'] {\n  color: #171a17;\n  background: #eef2ef;\n  border-color: #dfe5e1;\n}\n\n.InspirationCanvas-project-menu-popover {\n  position: absolute;\n  z-index: 30;\n  top: calc(100% + 7px);\n  right: 0;\n  display: grid;\n  min-width: 136px;\n  gap: 2px;\n  padding: 5px;\n  background: #fff;\n  border: 1px solid #dfe5e1;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(24, 30, 26, 0.14);\n}\n\n.InspirationCanvas-project-menu-popover button {\n  width: 100%;\n  padding: 8px 9px;\n  color: #4f5b52;\n  background: transparent;\n  border: 0;\n  border-radius: 5px;\n  font-size: 11px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.InspirationCanvas-project-menu-popover button:hover {\n  color: #171a17;\n  background: #f1f3f2;\n}\n\n.InspirationCanvas-project-menu-popover button.is-danger {\n  color: #c1514b;\n}\n\n.InspirationCanvas-project-menu-popover button.is-danger:hover {\n  color: #a33c37;\n  background: #fff0ee;\n}\n\n.InspirationCanvas-project-menu-divider {\n  height: 1px;\n  margin: 3px 2px;\n  background: #e8ece9;\n}\n\n.InspirationCanvas-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.InspirationCanvas-card-moderation-status {\n  display: inline-flex;\n  margin-top: 7px;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: #fee8e5;\n  color: #a43b34;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.InspirationCanvas-moderation-notice {\n  display: grid;\n  gap: 4px;\n  margin-top: 10px;\n  padding: 11px 12px;\n  border: 1px solid #efc1bc;\n  border-radius: 9px;\n  background: #fff4f2;\n  color: #8d332d;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.InspirationCanvas-moderation-notice span { color: #a1554f; }\n\n@media (max-width: 820px) {\n  .InspirationCanvas-header-inner {\n    min-height: 170px;\n    place-items: center;\n    padding: 32px 1rem 24px;\n  }\n\n  .InspirationCanvas-main { padding: 1rem 1rem 3rem; }\n}\n\n/* 操作按钮 - 悬停显示 */\n.InspirationCanvas-card-actions {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  gap: 6px;\n  z-index: 10;\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-actions {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.InspirationCanvas-action-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(4px);\n  border: none;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.InspirationCanvas-action-btn:hover {\n  background: white;\n  transform: scale(1.1);\n}\n\n.InspirationCanvas-delete-btn:hover {\n  color: #ef4444;\n}\n\n.InspirationCanvas-edit-btn:hover {\n  color: #3b82f6;\n}\n\n/* 创建卡片 - 极简风格 */\n.InspirationCanvas-create-card {\n  background: white;\n  /* border-radius: 8px; */\n  border: 2px dashed #cbd5e1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-height: 200px; /* 不需要太高 */\n  box-shadow: none;\n  height: 100%; /* 撑满 */\n}\n\n.InspirationCanvas-create-card:hover {\n  border-color: #94a3b8;\n  background: #f8fafc;\n}\n\n.InspirationCanvas-create-content {\n  text-align: center;\n  padding: 1.5rem;\n}\n\n.InspirationCanvas-create-icon {\n  color: #94a3b8;\n  margin-bottom: 0.75rem;\n  transition: transform 0.3s ease;\n}\n\n.InspirationCanvas-create-card:hover .InspirationCanvas-create-icon {\n  transform: scale(1.1) rotate(90deg);\n  color: #64748b;\n}\n\n.InspirationCanvas-create-text {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #64748b;\n  margin: 0;\n}\n\n/* 状态提示 */\n.InspirationCanvas-loading,\n.InspirationCanvas-no-more,\n.InspirationCanvas-empty-message {\n  text-align: center;\n  padding: 3rem;\n  color: #94a3b8;\n  font-size: 0.95rem;\n  font-weight: 500;\n  width: 100%;\n}\n\n.InspirationCanvas-error {\n  text-align: center;\n  padding: 2rem;\n  background: #fef2f2;\n  border-radius: 12px;\n  border: 1px solid #fecaca;\n  margin-bottom: 2rem;\n  color: #b91c1c;\n}\n\n/* 对话框样式 */\n.InspirationCanvas-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6); /* 加深背景 */\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.InspirationCanvas-dialog {\n  background: white;\n  border-radius: 24px;\n  padding: 2.5rem;\n  width: 100%;\n  max-width: 480px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: dialogPop 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes dialogPop {\n  from { opacity: 0; transform: scale(0.95); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.InspirationCanvas-dialog-title {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 1.5rem 0;\n  text-align: center;\n}\n\n.InspirationCanvas-form-input,\n.InspirationCanvas-form-textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  transition: all 0.2s;\n  background: #f8fafc;\n  color: #1e293b;\n}\n\n.InspirationCanvas-form-input:focus,\n.InspirationCanvas-form-textarea:focus {\n  background: white;\n  border-color: #0f172a;\n  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);\n  outline: none;\n}\n\n.InspirationCanvas-dialog-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 2rem;\n}\n\n.InspirationCanvas-dialog-button {\n  flex: 1;\n  padding: 12px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.InspirationCanvas-dialog-button-cancel {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.InspirationCanvas-dialog-button-cancel:hover {\n  background: #e2e8f0;\n  color: #334155;\n}\n\n.InspirationCanvas-dialog-button-save {\n  background: #0f172a;\n  color: white;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);\n}\n\n.InspirationCanvas-dialog-button-save:hover {\n  background: #1e293b;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.25);\n}\n\n.InspirationCanvas-dialog-button-delete {\n  background: #ef4444;\n  color: white;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n.InspirationCanvas-dialog-button-delete:hover {\n  background: #dc2626;\n  transform: translateY(-1px);\n}\n\n.InspirationCanvas-cover-dialog {\n  max-width: 760px;\n  padding: 24px;\n}\n\n.InspirationCanvas-cover-dialog-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.InspirationCanvas-cover-dialog-header .InspirationCanvas-dialog-title {\n  margin-bottom: 6px;\n  text-align: left;\n}\n\n.InspirationCanvas-cover-dialog-subtitle {\n  margin: 0;\n  color: #737b75;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.InspirationCanvas-cover-dialog-close {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 auto;\n  place-items: center;\n  padding: 0;\n  color: #737b75;\n  background: #f1f3f2;\n  border: 1px solid #e1e7e3;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;\n}\n\n.InspirationCanvas-cover-dialog-close:hover {\n  color: #171a17;\n  background: #e7ebe8;\n  border-color: #d3dbd5;\n}\n\n.InspirationCanvas-cover-dialog-close:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.InspirationCanvas-cover-picker {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n  max-height: min(55vh, 460px);\n  overflow-y: auto;\n  padding: 2px;\n}\n\n.InspirationCanvas-cover-option {\n  min-width: 0;\n  padding: 0;\n  color: #4f5b52;\n  text-align: left;\n  background: #fff;\n  border: 1px solid #dfe5e1;\n  border-radius: 9px;\n  cursor: pointer;\n  overflow: hidden;\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n\n.InspirationCanvas-cover-option:hover {\n  border-color: #a9c880;\n  box-shadow: 0 6px 16px rgba(54, 73, 57, 0.11);\n  transform: translateY(-1px);\n}\n\n.InspirationCanvas-cover-option:focus-visible,\n.InspirationCanvas-cover-dialog-close:focus-visible,\n.InspirationCanvas-cover-upload-button:focus-visible,\n.InspirationCanvas-cover-retry:focus-visible {\n  outline: 3px solid rgba(126, 174, 71, 0.3);\n  outline-offset: 2px;\n}\n\n.InspirationCanvas-cover-option.is-selected {\n  border-color: #7eae47;\n  box-shadow: 0 0 0 2px rgba(126, 174, 71, 0.2);\n}\n\n.InspirationCanvas-cover-option-image {\n  position: relative;\n  display: block;\n  aspect-ratio: 4 / 3;\n  background: #e8eeea;\n}\n\n.InspirationCanvas-cover-option-image img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.InspirationCanvas-cover-option-check {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: grid;\n  width: 26px;\n  height: 26px;\n  place-items: center;\n  color: #fff;\n  background: #7eae47;\n  border-radius: 50%;\n  box-shadow: 0 2px 8px rgba(40, 62, 34, 0.24);\n}\n\n.InspirationCanvas-cover-option-label {\n  display: block;\n  overflow: hidden;\n  padding: 9px 10px 10px;\n  color: #4f5b52;\n  font-size: 11px;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.InspirationCanvas-cover-state {\n  display: flex;\n  min-height: 180px;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  padding: 24px;\n  color: #5e6a61;\n  background: #f5f7f5;\n  border: 1px dashed #d3ddd5;\n  border-radius: 9px;\n  font-size: 13px;\n}\n\n.InspirationCanvas-cover-state.is-error,\n.InspirationCanvas-cover-state.is-empty {\n  flex-direction: column;\n  text-align: center;\n}\n\n.InspirationCanvas-cover-state.is-error {\n  color: #a33c37;\n  background: #fff5f3;\n  border-color: #efc1bc;\n}\n\n.InspirationCanvas-cover-state.is-error span,\n.InspirationCanvas-cover-state.is-empty span {\n  color: #737b75;\n  font-size: 12px;\n}\n\n.InspirationCanvas-cover-retry {\n  padding: 7px 12px;\n  color: #4f7e2e;\n  background: #e3f3cb;\n  border: 1px solid #b9df8a;\n  border-radius: 7px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.InspirationCanvas-cover-retry:hover {\n  background: #d8efb9;\n  border-color: #8fbd5c;\n}\n\n.InspirationCanvas-cover-retry:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.InspirationCanvas-cover-state.is-empty svg {\n  color: #9aaa9d;\n  margin-bottom: 2px;\n}\n\n.InspirationCanvas-cover-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #d7e2ce;\n  border-top-color: #7eae47;\n  border-radius: 50%;\n  animation: InspirationCanvas-cover-spin 700ms linear infinite;\n}\n\n@keyframes InspirationCanvas-cover-spin {\n  to { transform: rotate(360deg); }\n}\n\n.InspirationCanvas-cover-dialog-footer {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.InspirationCanvas-cover-dialog-footer .InspirationCanvas-dialog-actions {\n  min-width: 260px;\n  margin-top: 0;\n}\n\n.InspirationCanvas-cover-upload-button {\n  padding: 10px 2px;\n  color: #657461;\n  background: transparent;\n  border: 0;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.InspirationCanvas-cover-upload-button:hover {\n  color: #4f7e2e;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.InspirationCanvas-cover-upload-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n/* 升级弹窗相关复用 */\n.InspirationCanvas-upgrade-dialog {\n  text-align: center;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.InspirationCanvas-upgrade-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  margin: 0 auto 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.InspirationCanvas-upgrade-message {\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  color: #0369a1;\n  padding: 1rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.InspirationCanvas-upgrade-benefits {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 2rem 0;\n  text-align: left;\n}\n\n.InspirationCanvas-upgrade-benefits li {\n  padding: 0.5rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #475569;\n}\n\n.InspirationCanvas-upgrade-benefits li::before {\n  content: '✓';\n  color: #10b981;\n  font-weight: 800;\n}\n\n.InspirationCanvas-upgrade-button {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: white;\n}\n\n/* 移动端适配 */\n@media (max-width: 768px) {\n  .InspirationCanvas-body {\n    width: calc(100% - 76px);\n    margin-left: 76px;\n  }\n\n  .InspirationCanvas-header-inner {\n    min-height: 150px;\n    padding: 24px 12px 20px;\n  }\n\n  .InspirationCanvas-main {\n    padding: 1rem 1rem 3rem;\n  }\n\n  .InspirationCanvas-campaign {\n    grid-template-columns: 1fr;\n    gap: 22px;\n    padding: 24px;\n  }\n\n  .InspirationCanvas-campaign-reward {\n    grid-template-columns: auto auto 1fr;\n    min-width: 0;\n    justify-items: start;\n    align-items: baseline;\n    gap: 6px;\n    padding: 20px 0 0;\n    border-top: 1px solid #d7e2ce;\n    border-left: 0;\n  }\n\n  .InspirationCanvas-campaign-reward > strong { font-size: 38px; }\n  .InspirationCanvas-campaign-reward button { grid-column: 1 / -1; }\n  \n  .InspirationCanvas-masonry-container {\n    gap: 2px;\n  }\n  \n  .InspirationCanvas-masonry-column {\n    gap: 2px;\n  }\n\n  .InspirationCanvas-skeleton-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  \n  .InspirationCanvas-create-card {\n    min-height: 160px;\n  }\n\n  .InspirationCanvas-login-prompt {\n    grid-template-columns: auto 1fr;\n    gap: 14px;\n    padding: 22px;\n  }\n\n  .InspirationCanvas-login-prompt button { grid-column: 1 / -1; }\n}\n\n@media (max-width: 720px) {\n  .InspirationCanvas-header .InspirationCanvas-header-inner {\n    min-height: 140px;\n    padding: 20px 10px;\n  }\n\n  .InspirationCanvas-heading h1 {\n    gap: 8px;\n    font-size: 24px;\n  }\n\n  .InspirationCanvas-heading h1 .InspirationCanvas-brand-logo {\n    width: calc(100% - 108px);\n    max-width: 100%;\n  }\n\n  .InspirationCanvas-body {\n    width: calc(100% - 68px);\n    margin-left: 68px;\n  }\n}\n\n@media (max-width: 620px) {\n  .InspirationCanvas-skeleton-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .InspirationCanvas-cover-dialog {\n    padding: 18px;\n  }\n\n  .InspirationCanvas-cover-picker {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 9px;\n    max-height: 52vh;\n  }\n\n  .InspirationCanvas-cover-dialog-footer {\n    align-items: stretch;\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n\n  .InspirationCanvas-cover-dialog-footer .InspirationCanvas-dialog-actions {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .InspirationCanvas-cover-upload-button {\n    align-self: flex-start;\n  }\n\n  .InspirationCanvas-body.is-mine .InspirationCanvas-main {\n    padding: 28px 14px 56px;\n  }\n\n  .InspirationCanvas-section-header {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 14px;\n    margin-bottom: 22px;\n  }\n\n  .InspirationCanvas-create-project-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .InspirationCanvas-masonry-container.is-mine-projects {\n    grid-template-columns: 1fr;\n    gap: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
